import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=eba56dfe&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disks/apps/api/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('eba56dfe', component.options)
    } else {
      api.reload('eba56dfe', component.options)
    }
    module.hot.accept("./LayoutFooter.vue?vue&type=template&id=eba56dfe&", function () {
      api.rerender('eba56dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/LayoutFooter.vue"
export default component.exports